import {connect} from 'react-redux';
import {
  peopleWithPointsSelector,
  peopleLoadingSelector,
} from '../../../reducers';
import People from './component';

const mapStateToProps = (state) => {
  return {
    people: peopleWithPointsSelector(state) || {},
    loading: peopleLoadingSelector(state) ? true : false,
  };
};

export default connect(mapStateToProps)(People);



// WEBPACK FOOTER //
// ./src/component/organisms/PeopleList/index.js